import { Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { InternalContractDetail } from '../../BaseController/types/internalContract';
import { ContractDataItem } from './contractDataItem';

export interface ContractDataProps {
  contractDetails: InternalContractDetail;
}

export const ContractData = ({ contractDetails }: ContractDataProps) => {
  const { t } = useTranslation();

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Stack direction="column" spacing={3}>
        <Stack>
          <Typography variant="headlineVehicle">
            {contractDetails.equipmentName}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={8}>
          <ContractDataItem
            text={contractDetails.equipmentSerialNr}
            label={t('SerialNumber')}
          />
          <ContractDataItem
            text={contractDetails.yearOfConstruction}
            label={t('YearOfConstruction')}
          />
        </Stack>
        <Divider light />
        <Stack spacing={2}>
          <Typography variant="headlineDetailSection">
            {t('ContractDetails')}
          </Typography>
          <Stack>
            <Stack direction="row" spacing={8}>
              <Stack spacing={3}>
                <ContractDataItem
                  text={contractDetails.contractNr}
                  label={t('ContractNumber')}
                />
                <ContractDataItem
                  text={contractDetails.beginDate}
                  label={t('ContractBeginDate')}
                />
              </Stack>
              <Stack spacing={3}>
                <ContractDataItem
                  text={contractDetails.contractSubType}
                  label={t('ContractType')}
                  subText={contractDetails.contractType}
                />
                <ContractDataItem
                  text={contractDetails.endDate}
                  label={t('ContractEndDate')}
                />
              </Stack>
              <Stack spacing={3}>
                <ContractDataItem
                  text={contractDetails.agreedOperatingHours}
                  label={t('AgreedOperatingHours')}
                />
                {/* eslint-disable-next-line no-nested-ternary */}
                {contractDetails.contractUsageName === 'pbth' ? (
                  contractDetails.hourlyRate && contractDetails.rate ? (
                    <Stack direction="row" spacing={8}>
                      <ContractDataItem
                        text={contractDetails.hourlyRate}
                        label={t('HourlyRate')}
                      />
                      <ContractDataItem
                        text={contractDetails.rate}
                        label={t('BaseRate')}
                      />
                    </Stack>
                  ) : null
                ) : contractDetails.rate ? (
                  <ContractDataItem
                    text={contractDetails.rate}
                    label={t('Rate')}
                  />
                ) : null}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};
